import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { router } from './router'
import { StatusProvider } from './contexts/StatusProvider'
import { ArcoLocaleProvider } from './i18n/ArcoLocaleProvider'
import './i18n'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ArcoLocaleProvider>
        <StatusProvider>
          <RouterProvider router={router} />
        </StatusProvider>
      </ArcoLocaleProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
